const valideUtil = {
  /** 正则表达式：验证身份证 */
  REGEX_ID_CARD: /(^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$)|(^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$)/,
  /** 正则表达式：验证户口簿 9位数字 */
  REGEX_HUKOU_CARD: /\\d{9}/,
  /** 正则表达式：验证护照 数字+字母，共9位 */
  REGEX_PASSPORT_CARD: /^([a-zA-z]|[0-9]){9}$/,
  /** 正则表达式：验证军官证 汉字+8位数字 */
  REGEX_OFFICER_CARD: /^[\u4e00-\u9fa5](字第)([0-9a-zA-Z]{4,8})(号?)$/,
  /** 正则表达式：验证驾驶证 12位数字 */
  REGEX_DRIVE_CARD: /\\d{12}$/,
  /** 正则表达式：验证港澳居民通行证 H/M + 10位或8位数字 */
  REGEX_HK_CARD: /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/,
  /** 正则表达式：验证台湾居民通行证 新版8位或18位数字,旧版10位数字 + 英文字母 */
  REGEX_TW_CARD: /^\\d{8}|^[a-zA-Z0-9]{10}|^\\d{18}$/,
  /** 正则表达式： 11923103 8位 前2位学校编码 后6位为学校自己编排的号码（年级（1位）+专业编号（2位）+班级（1位）+班内序号（2位）） */
  REGEX_STUDENT_CARD: /^[0-9]{8}$/,
  /** 11位手机号验证规则 */
  PHONE_REG: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
  /** 固话验证规则 */
  TEL_REG: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,4}))?$/,
  /** 邮箱验证规则 */
  MAIL_REG: /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
  /** 0或非0开头的正整数 */
  NONNEGATIVE_INT_RES: /^(0|[1-9][0-9]*)$/,
  /** 正整数 */
  POSITIVE_INT_RES: /^([1-9][0-9]*)$/,
  /**
   * 邮箱验证
   * @param {*} value 
   * @returns 
   */
  isEmail: function (value) {
    return this.MAIL_REG.test(value)
  },

  /**
   * 手机号校验
   * @param {*} value 
   * @returns 
   */
  isPhone: function (value) {
    return this.PHONE_REG.test(value)
  },

  /**
   * 固话验证
   * @param {*} value 
   * @returns 
   */
  isTel: function (value) {
    return this.TEL_REG.test(value)
  },

  /**
   * 校验身份证
   *
   * @param idCardNo 身份证号
   * @return 校验通过返回true，否则返回false
   */
  isIDCard: function (idCardNo) {
    try {
      var idCardNo = idCardNo.toUpperCase() // 身份证为末尾可能是X
      let matches = this.REGEX_ID_CARD.test(idCardNo)
      //判断第18位校验值
      if (matches) {
        //   身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，
        //   最后一位是校验位，可能为数字或字符X。
        const arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
        const arrCh = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2")
        let nTemp = 0
        //   校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        //   下面分别分析出生日期和校验位
        if (idCardNo.length == 15) {
          let re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/)
          let arrSplit = idCardNo.match(re)
          //   检查生日日期是否正确
          let dtmBirth = new Date(
            "19" + arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
          )
          if (dtmBirth.getYear() == Number(arrSplit[2]) && dtmBirth.getMonth() + 1 == Number(arrSplit[3]) && dtmBirth.getDate() == Number(arrSplit[4])) {
            //   将15位身份证转成18位
            //   校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            idCardNo = idCardNo.substr(0, 6) + "19" + idCardNo.substr(6, idCardNo.length - 6)
            for (let i = 0; i < 17; i++) {
              nTemp += idCardNo.substr(i, 1) * arrInt[i]
            }
            idCardNo += arrCh[nTemp % 11]
            return true
          }
        } else if (idCardNo.length == 18) {
          let re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/)
          let arrSplit = idCardNo.match(re)
          //  检查生日日期是否正确
          let dtmBirth = new Date(
            arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
          )
          if (dtmBirth.getFullYear() == Number(arrSplit[2]) && dtmBirth.getMonth() + 1 == Number(arrSplit[3]) && dtmBirth.getDate() == Number(arrSplit[4])) {
            //  检验18位身份证的校验码是否正确。
            //  校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            var valnum
            for (let i = 0; i < 17; i++) {
              nTemp += idCardNo.substr(i, 1) * arrInt[i]
            }
            valnum = arrCh[nTemp % 11]
            if (valnum == idCardNo.substr(17, 1)) {
              //  18位身份证的校验码不正确！
              return true
            }
          }
        }
      }
    } catch (error) {
      console.log("valide isIDCard error", error)
    }
    return false
  },

  /**
  * 校验户口簿
  *
  * @param huKouNo 户口簿号
  * @return 校验通过返回true，否则返回false
  */
  isHuKouCard: function (huKouNo) {
    return this.REGEX_HUKOU_CARD.test(huKouNo)
  },

  /**
  * 校验护照
  *
  * @param passPortNo 护照号
  * @return 校验通过返回true，否则返回false
  */
  isPassPortCard: function (passPortNo) {
    return this.REGEX_PASSPORT_CARD.test(passPortNo)
  },

  /**
  * 校验军官证
  * 规则： 军/兵/士/文/职/广/（其他中文） + "字第" + 4到8位字母或数字 + "号"
  * 样本： 军字第2001988号, 士字第P011816X号
  * @param officerNo 军官证号
  * @return 校验通过返回true，否则返回false
  */
  isOfficerCard: function (officerNo) {
    return this.REGEX_OFFICER_CARD.test(officerNo)
  },

  /**
  * 校验驾驶证
  *
  * @param driveNo 驾驶证号
  * @return 校验通过返回true，否则返回false
  */
  isDriveCard: function (driveNo) {
    return this.REGEX_DRIVE_CARD.test(driveNo)
  },

  /**
  * 校验港澳通行证
  *
  * @param HMNo 港澳通行证号
  * @return 校验通过返回true，否则返回false
  */
  isHMCard: function (HMNo) {
    return this.REGEX_HK_CARD.test(HMNo)
  },

  /**
  * 校验台湾通行证
  * 规则 新版8位或18位数字,旧版10位数字 + 英文字母
  * @param TWNo 台湾通行证号
  * @return 校验通过返回true，否则返回false
  */
  isTWCard: function (TWNo) {
    return this.REGEX_TW_CARD.test(TWNo)
  },

  /**
   * 学生证 
   * 规则 8位 2位学校代码+6位个人信息
   * @param {*} code 
   * @returns 
   */
  isStudentCard: function (code) {
    return this.REGEX_STUDENT_CARD.test(code)
  },

  /**
   * 证件号码的统一验证
   * @param {*} paperType 
   * @param {*} value 
   * @param {*} callback 
   * @param {*} rule 
   */
  checkPaperCode: function (paperType, value, callback, rule) {
    if (value != undefined && value.trim() != "") {
      let success = true
      let label = '证件号码格式异常'
      switch (paperType) {
        case 'ID_CARD':
          //居民身份证
          success = this.isIDCard(value)
          if (!success) label = '身份证号码格式异常'
          break
        case 'HK_M_PASSPORT':
          //"港澳通行证",
          success = this.isHMCard(value)
          if (!success) label = '港澳居民通行证号码规则H/M + 10位或8位数字'
          break
        case 'TW_PASSPORT':
          //"台湾通行证",
          success = this.isTWCard(value)
          if (!success) label = '台湾居民通行证号码规则新版8位或18位数字,旧版10位数字 + 英文字母'
          break
        case 'OFFICER_CARD':
          //军官证 汉字+8位数字
          success = this.isOfficerCard(value)
          // 例如：海字第1234abcd(号)
          if (!success) label = '军官证号码规则一位汉字+字第+4-8位数字或英文'
          break
        case 'STUDENT_CARD':
          //学生证 code
          success = this.isStudentCard(value)
          if (!success) label = '学生证号码规则8位数字(2位学校代码+6位个人信息编码)'
          break
        case 'PASSPORT':
          //护照
          success = this.isPassPortCard(value)
          if (!success) label = '护照号码规则数字+字母共9位'
          break
        case 'HUKOU_CARD':
          //户口簿
          success = this.isHuKouCard(value)
          if (!success) label = '户口簿号码规则9位数字'
          break
        case 'DRIVE_CARD':
          //驾驶证
          success = this.isDriveCard(value)
          if (!success) label = '驾驶证号码规则12位数字'
          break
        default:
          //其他
          break
      }
      if (!success) {
        callback(new Error(label))
      } else {
        callback()
      }
    } else {
      if (rule.required) {
        callback(new Error("请填写证件号码"))
      } else {
        callback()
      }
    }
  },

  /**
   * 非负整数
   * @param {*} num 
   * @param {*} callback 
   * @param {*} rule 
   */
  isNonnegativeInt: function (num, callback, rule, message) {
    console.log('isNonnegativeInt', num)
    if (num != undefined || num != null || num != '') {
      if (this.NONNEGATIVE_INT_RES.test(num)) {
        callback()
      } else {
        callback(new Error("请填写非负整数"))
      }
    } else if (rule.required) {
      callback(new Error(message))
    }
  },
  isPositiveInt: function (num, callback, rule, message) {
    console.log('isPositiveInt', num)
    if (num != undefined || num != null || num != '') {
      if (this.POSITIVE_INT_RES.test(num)) {
        callback()
      } else {
        callback(new Error("请填写正整数"))
      }
    } else if (rule.required) {
      callback(new Error(message))
    }
  },
}

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$valideUtil', { value: valideUtil })
  },
}
